/* eslint-disable */
import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import { history } from 'index'
import { push } from 'connected-react-router'
import AuthService from 'services/auth'
import routeNames from 'routeNames/pageRouteNames'
import actions from './actions'
import menuActions from '../menu/actions'
import ticketActions from '../tickets/actions'
import usersActions from '../users/actions'
import { getMachineId, requestNotificationPermission } from 'firebaseMessaging'

const services = new AuthService()

export function* LOGIN({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  })

  const success = yield call(services.login, payload)
  if (success) {
    const accessToken = success.data.data.access_token
    localStorage.setItem('accessToken', accessToken)
    yield put({
      type: actions.LOAD_CURRENT_ACCOUNT,
    })
    yield put(push(payload && payload.next ? payload.next : '/dashboard'))
    notification.success({
      message: 'Logged In',
      description: 'You have successfully logged in!',
    })

    try {
      const machineId = yield call(getMachineId)

      localStorage.setItem('machineId', machineId)

      // request permission & get token
      const fcmToken = yield call(requestNotificationPermission)
      const authToken = localStorage.getItem('authToken')
      if (fcmToken && authToken) {
        yield call(services.addDevice, {
          body: { fcmToken, machineId },
        })
        console.log('✅ FCM token registered after login')
      }
    } catch (err) {
      console.error('❌ Failed to register FCM token after login:', err)
    }
  }

  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
    },
  })
}

export function* LOAD_CURRENT_ACCOUNT() {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  })
  if (localStorage.getItem('accessToken')) {
    const response = yield call(services.getProfile)
    if (response) {
      let allRoles = yield call(services.getRoles)
      allRoles = allRoles.data.data
      const {
        id,
        name,
        profilePicture,
        status,
        email,
        roles,
        organization,
        permissions,
        phoneNumber,
        notificationPreference,
      } = response?.data?.data
      yield put({
        type: actions.SET_STATE,
        payload: {
          authorized: true,
          id,
          name,
          profilePicture,
          status,
          email,
          phoneNumber,
          allRoles,
          roles,
          organization,
          permissions,
          notificationPreference,
        },
      })
      const isDefault = roles.map((r) => r.isDefault)
      yield put({
        type: menuActions.GET_DATA,
        payload: { permissions, id, isDefault },
      })
    }
  }
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
    },
  })
}

export function* LOGOUT() {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  })
  localStorage.clear('accessToken')
  localStorage.clear('machineId')

  yield put({
    type: usersActions.SET_STATE,
    payload: {
      users: [],
      selectedUser: null,
      organizations: [],
      authorized: false,
      loading: false,
      developers: [],
      devops: [],
      pagination: {},
    },
  })
  yield put({
    type: ticketActions.SET_STATE,
    payload: {
      tickets: [],
      loading: false,
      id: '',
      uuid: '',
      referenceId: '',
      type: '',
      status: '',
      userId: '',
      user: {},
      formFields: {},
      participants: [],
      updates: [],
      comments: [],
      assignedTo: null,
      pagination: {},
    },
  })
  yield put(push(routeNames.LOGIN.path))
  notification.success({
    message: 'Logged Out',
    description: 'You have successfully logged out!',
  })
  yield put({
    type: actions.SET_STATE,
    payload: {
      id: '',
      name: '',
      allRoles: [],
      profilePicture: '',
      organizationId: '',
      status: '',
      email: '',
      roles: '',
      organization: '',
      permissions: [],
      authorized: false,
      loading: false,
    },
  })
}

export function* UPDATE_PROFILE({ payload, resolve, reject }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  })

  try {
    const response = yield call(services.updateProfile, { body: payload })

    if (response) {
      if (payload.notificationPreference) {
        yield put({
          type: actions.SET_STATE,
          payload: {
            notificationPreference: payload.notificationPreference,
          },
        })
        notification.success({
          message: 'Notification preferences updated successfully.',
        })
      } else {
        notification.success({
          message: 'Profile Updated Successfully',
        })
      }

      yield put({
        type: actions.LOAD_CURRENT_ACCOUNT,
      })
      history.push('/dashboard')

      if (resolve) resolve(response)
    }
  } catch (error) {
    if (reject) reject(error)
  } finally {
    yield put({
      type: actions.SET_STATE,
      payload: {
        loading: false,
      },
    })
  }
}

export function* SEND_OTP({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: { loading: true },
  })

  try {
    const response = yield call(services.sendOtp, { body: payload })
    if (response) {
      yield put({
        type: actions.SET_STATE,
        payload: { loading: false, otpSent: true },
      })
      notification.success({
        message: 'OTP Sent',
        description: 'OTP has been sent successfully!',
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: { loading: false, otpSent: false },
    })
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOGIN, LOGIN),
    takeEvery(actions.LOAD_CURRENT_ACCOUNT, LOAD_CURRENT_ACCOUNT),
    takeEvery(actions.LOGOUT, LOGOUT),
    takeEvery(actions.UPDATE_PROFILE, UPDATE_PROFILE),
    takeEvery(actions.SEND_OTP, SEND_OTP),
    LOAD_CURRENT_ACCOUNT(), // run once on app load to check user auth
  ])
}
